/**
 * status 从未设置：0 匿名状态 1: 开启 2: 关闭
 */
export var PersonalizeAnonymousStatus;
(function (PersonalizeAnonymousStatus) {
    PersonalizeAnonymousStatus[PersonalizeAnonymousStatus["NONE"] = 0] = "NONE";
    PersonalizeAnonymousStatus[PersonalizeAnonymousStatus["OPEN"] = 1] = "OPEN";
    PersonalizeAnonymousStatus[PersonalizeAnonymousStatus["CLOSED"] = 2] = "CLOSED";
})(PersonalizeAnonymousStatus || (PersonalizeAnonymousStatus = {}));
